import { Button, Group, Text } from "@mantine/core";
import { EmptyState, ErrorState, LoadingState } from "@/components/states";
import type { DeletionQueue } from "./types";

export function QueueState<T>({
  queue,
  emptyTitle,
}: {
  queue: DeletionQueue<T>;
  emptyTitle: string;
}) {
  if (queue.error) return <ErrorState error={queue.error} />;
  if (queue.loading && !queue.items.length) return <LoadingState />;
  if (!queue.items.length) return <EmptyState title={emptyTitle} />;
  return null;
}

export function QueueFooter<T>({ queue }: { queue: DeletionQueue<T> }) {
  if (!queue.items.length) return null;
  return (
    <Group justify="space-between" mt="md">
      <Text size="xs" c="dimmed">
        {queue.items.length} loaded
      </Text>
      {queue.hasMore ? (
        <Button variant="default" size="xs" loading={queue.loading} onClick={queue.onLoadMore}>
          Load more
        </Button>
      ) : null}
    </Group>
  );
}
